import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import './MenuDivider.scss';

class MenuDivider extends Component {
  static defaultProps = {
    variant: 'default',
  }

  render() {
    const {variant, parentClassName} = this.props;
    
    const baseClassName = 'pb-menu-divider';

    const classes = {
      [baseClassName]: true,
      [parentClassName]: parentClassName,
      [`${baseClassName}--${variant}`]: variant
    };

    return (
      <hr className={classNames(classes)} />
    );
  }
}

MenuDivider.propTypes = {

  variant: PropTypes.oneOf([
    'default',
    'padding',
  ]),
 
};
export default MenuDivider;



// WEBPACK FOOTER //
// ./src/components/MenuDivider/MenuDivider.jsx